// Slime chunks (MB.6 natural spawn weights). PURE (ENG-1). Slimes only spawn in
// ~1-in-10 "slime chunks", fixed per world seed and chunk coords (like Java's
// hash) so the same chunk always agrees. The spawner gates slime picks on this.
import { Rng } from '../engine/rng';

/** One in this many chunks is a slime chunk (Java ~1/10). */
export const SLIME_CHUNK_RATE = 10;

/** Whether chunk (cx,cz) is a slime chunk for `seed` — reproducible from the
 *  coordinates alone, so it never changes for a given world. */
export function isSlimeChunk(cx: number, cz: number, seed: number | string | bigint): boolean {
  return new Rng(`slime:${String(seed)}:${cx}:${cz}`).nextInt(SLIME_CHUNK_RATE) === 0;
}
